import { render, staticRenderFns } from "./loginlog.vue?vue&type=template&id=0b48ba5e&scoped=true&"
import script from "./loginlog.vue?vue&type=script&lang=js&"
export * from "./loginlog.vue?vue&type=script&lang=js&"
import style0 from "./loginlog.vue?vue&type=style&index=0&id=0b48ba5e&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b48ba5e",
  null
  
)

export default component.exports